import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from 'components/SectionHeader'
import { Spacing50 } from 'styles/sharedStyle'
import { Grid, Wrapper } from './VillageGrid.style'
import VillageGridCard from './VillageGridCard'

const VillageGrid = ({ headline, cards, villageName }) => {
  return (
    <Wrapper>
      <SectionHeader title={headline} />
      <Grid>
        {cards.map((card, i) => (
          <VillageGridCard
            {...card}
            key={`card_${i.toString()}`}
            headline={headline}
            villageName={villageName}
          />
        ))}
      </Grid>
      <Spacing50 />
    </Wrapper>
  )
}

VillageGrid.propTypes = {
  headline: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  villageName: PropTypes.string,
}

VillageGrid.defaultProps = {
  headline: 'Our Villages',
  cards: [],
  villageName: '',
}

export default VillageGrid
